import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import { getAllData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage, GetLocalStorage } from '../../../commonClass/Session';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { getDateCombination, isImageValidPng, onlyNumeric } from '../../../commonClass/CommonValidation';
import { CommonFileURLWithFolder, ImageDelete, ImageUpload } from '../../../../ImageUpload/ImageCommon';
import CustomTable from '../../../../customControl/CustomTable';
import { useLocation } from 'react-router-dom';
import { getTitleName } from './HomePageSection';
import CommonFilter from '../../../../customControl/CommonFilter';

const Domestic = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { useredit, useradd, name, travelCategoryId, HomePageSectionId, folderName, section } = location.state || {};
    const [countryCity, setCountryCity] = useState();
    const [city, setCity] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [formError, setFormError] = useState({});
    const [deletedImage, setDeletedImage] = useState([]);
    const [stateId, setStateId] = useState(0)
    const [pricedata, setPriceData] = useState({});
    const [activityList, setActivityList] = useState([])
    const [editDisable, setEditDisable] = useState(true)

    const [searchvalue, setSearchValue] = useState('');
    const [searchby, setSerachBy] = useState('All');
    const [serchdisable, setSerachDisable] = useState(false);

    const [galleryList, setGalleryList] = useState([]);

    const [formValue, setFormValue] = useState(
        {
            UserId: 0,
            HolidaysId: 0,
            HomePageSectionId: HomePageSectionId,
            LocationId: 0,
            ImagePath: "",
            ImageName: "",
            ImageFile: "",
            SeqNo: '',
            GalleryId: 0,
            ActivityMerchandisingId: 0,
            //top indian 
            TopIndianMerchandisingId: 0,
            ActivityId: 0,
            Descriptions: ''
        }
    )

    const getcountrystatecity = async () => {
        const countrystatecity = await getAllData(`/master/v1/getcountrystatecity`);
        if (countrystatecity?.status) {
            setCountryCity({
                countryData: countrystatecity?.data?.countryData?.map((contry) => ({ label: contry?.CountryName, value: contry?.CountryId })),
                stateData: countrystatecity?.data?.stateData?.filter(val => val.CountryId === 1)?.map((city) => (
                    { label: city?.StateNAme, value: city?.StateId }
                )),
            });
            if (HomePageSectionId === 19 || HomePageSectionId === 16) {
                setCity(countrystatecity?.data?.cityData?.map((city) => (
                    { label: city?.City, value: city?.LocationId, CountryId: city?.CountryId, StateId: city?.StateId }
                )),
                );
            }

        }
        dispatch(loaderActions.end());
    }

    const getcity = async () => {
        const city = await getAllData(`/master/v1/getpackagecitylist`);
        if (city?.status) {
            setCity(city?.data?.map((city) => (
                { label: city?.City, value: city?.LocationId, CountryId: city?.CountryId, StateId: city?.StateId }
            )),
            );
        }
        dispatch(loaderActions.end());
    }

    const getActivityList = async () => {
        const list = await getAllData(`/master/v1/gettopindianmerchandisingoption`);
        if (list?.status) {
            setActivityList(list?.data?.activityList);
        }
    }

    const getdataendpointList = (homePageSectionId) => {
        let endpoint = '';
        switch (homePageSectionId) {
            case 4:
                endpoint = `/master/v1/getholidayslist?homePageSectionId=${homePageSectionId}`;
                break;
            case 19:
                endpoint = `/master/v1/GetActivityMerchandisingList?homePageSectionId=${homePageSectionId}`;
                break;
            default:
                endpoint = '/master/v1/gettopindianmerchandisinglist';
                break;
        }
        return endpoint
    }

    const getdatalist = async (HomePageSectionId) => {
        const data = await getAllData(getdataendpointList(HomePageSectionId))
        if (data?.status) {
            setDataList(data?.data)
            setFilterData(data?.data)
        }
        else {
            setDataList([])
            setFilterData([])
        }
        dispatch(loaderActions.end());
    }

    const getpriceanddiscount = async (id) => {
        if (HomePageSectionId === 4) {
            const data = await getAllData(`/master/v1/getpriceanddiscountbylocationid?locationId=${id}`);
            if (data?.status) {
                setPriceData(data?.data)
            }
        }
        dispatch(loaderActions.end());
    }

    const getgalleryforholiday = async () => {
        const galleryforholiday = await getAllData('/master/v1/getgalleryforholiday')
        if (galleryforholiday?.status) {
            setGalleryList(galleryforholiday?.data ? galleryforholiday?.data : [])
        }
        else {
            setGalleryList([]);
        }
    }

    const ImageList = useMemo(() => {
        if (formValue?.LocationId > 0 && galleryList?.length > 0) {
            return galleryList?.filter((fil) => fil.LocationId === formValue?.LocationId)?.map((obj) => {
                obj.value = obj.GalleryId
                obj.label =
                    <div className="text-center">
                        <img loading='lazy' style={{ objectFit: 'fill', width: '100px', height: '100px' }} src={`${CommonFileURLWithFolder}${obj?.ImagePath}`} alt="" />
                    </div>

                return obj;
            })
        }
        else {
            return [];
        }
    }, [galleryList, formValue?.LocationId])

    //#region List data
    useEffect(() => {
        dispatch(loaderActions.start());
        const fetchData = async () => {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                let token = GetLocalStorage();
                if (token && token.userName && token.token) {
                    getdatalist(HomePageSectionId);
                    getcountrystatecity();
                    if (HomePageSectionId === 4) {
                        getcity();
                        getgalleryforholiday();
                    }
                    if (HomePageSectionId === 16) {
                        getActivityList()
                    }
                }
            } else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData();
    }, []);

    const handleDropDown = (name, val) => {
        setEditDisable(false)
        setFormError({});
        if (name === 'StateId') {
            setFormValue((pre) => ({ ...pre, [name]: val.value, LocationId: 0, ImageName: '', ImagePath: '', GalleryId: 0 }));
            setStateId(val?.value)
            setPriceData({})
        }
        else {
            setFormValue((pre) => ({ ...pre, [name]: val.value, ImageName: '', ImagePath: '', GalleryId: 0 }));
            if (name === 'LocationId') {
                getpriceanddiscount(val.value)
            }
        }
    }

    const handleChange = (name, val) => {
        setEditDisable(false)
        setFormError({});
        setFormValue((pre) => ({ ...pre, [name]: val }));
    }

    const CityOptions = useMemo(() => city?.filter((city) => city?.StateId === stateId), [stateId]);

    const handleSelectImage = (img) => {
        setEditDisable(false)
        setFormError({});
        setFormValue((form) => ({ ...form, ImageName: img?.ImageFileName, ImagePath: img?.ImagePath, GalleryId: img?.GalleryId }));
    }

    const handleUploadImageLoad = (name, e) => {
        setEditDisable(false)
        setFormError({});
        if (isImageValidPng(e.target.files[0].name)) {
            const files = e.target.files[0];
            const filename = getDateCombination(files.name);
            setDeletedImage([...deletedImage, formValue?.ImagePath])
            setFormValue({
                ...formValue,
                ImageName: filename,
                ImagePath: `CMS/Merchandising/${folderName}/${section}/${filename}`,
                ImageFile: files,
            })
        }
        else {
            setFormError({
                ...formError, [name === 'FromImageName' ? 'ImageName' : '']: 'Only PNG file type is accepted.'
            });
        }
        e.target.value = null
    }

    const checkValidation = () => {
        let errorMessages = {};
        let isError = true;

        if (!stateId) {
            errorMessages['stateId'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (!formValue?.LocationId && stateId) {
            errorMessages['LocationId'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        if (HomePageSectionId === 4 || HomePageSectionId === 19) {
            if (!formValue?.ImagePath) {
                errorMessages['ImageName'] = HomePageSectionId === 4 ? 'Cannot leave blank, input is mandatory.' : 'Kindly upload an image.'
                isError = false;
            } else if (formValue?.ImageFile) {
                const files = formValue?.ImageFile;
                let fileSize = files.size / 1024;
                fileSize = fileSize / 1024
                if (!isImageValidPng(files.name) && files) {
                    errorMessages['ImageName'] = HomePageSectionId === 4 ? 'Only PNG file type is accepted.' : 'Only PNG file type is accepted.'
                    isError = false;
                } else if (fileSize > 5) {
                    errorMessages['ImageName'] = HomePageSectionId === 4 ? 'Cannot upload file that exceeds 5 MB.' : 'File size cannot exceed 5 MB.'
                    isError = false;
                }
            }
        }
        if (HomePageSectionId === 16) {
            if (formValue?.ActivityId <= 0) {
                errorMessages['ActivityId'] = 'Kindly select Activity name.'
                isError = false;
            }
        }
        if (!formValue?.SeqNo) {
            errorMessages['SeqNo'] = 'Cannot leave blank, input is mandatory.'
            isError = false;
        }
        else if (HomePageSectionId === 19) {
            if (dataList?.some((el) => el.ActivityMerchandisingId !== formValue?.ActivityMerchandisingId && el.SeqNo === formValue?.SeqNo)) {
                errorMessages['SeqNo'] = 'This number already exists.'
                isError = false;
            }
        }
        else if (HomePageSectionId === 16) {
            if (dataList?.some((el) => el.TopIndianMerchandisingId !== formValue?.TopIndianMerchandisingId && el.SeqNo === formValue?.SeqNo)) {
                errorMessages['SeqNo'] = 'Sequence number already exists. Please enter a unique value.'
                isError = false;
            }
        }

        setFormError(errorMessages);
        return isError;
    }

    const InsertendpointList = (homePageSectionId) => {
        let endpoint = '';
        switch (homePageSectionId) {
            case 4:
                endpoint = `/master/v1/insertorupdateholiday`;
                break;
            case 19:
                endpoint = `/master/v1/InsertOrUpdateActivityMerchandising`;
                break;
            default:
                endpoint = '/master/v1/insertorupdatetopindianactivitymerchandising';
                break;
        }
        return endpoint
    }

    const onSubmitData = async () => {
        const isValid = checkValidation();
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (isValid) {
                dispatch(loaderActions.start());
                let user = GetLocalStorage();
                formValue.UserId = user?.userMasterID
                const updateNewsLetter = await postUsersData(InsertendpointList(HomePageSectionId), formValue)
                if (updateNewsLetter.status) {
                    formValue?.ImageFile && await ImageUpload(`CMS/Merchandising/${folderName}/${section}/`, formValue?.ImageName, formValue?.ImageFile);
                    deletedImage.length > 0 && deletedImage.forEach(async (deletedImagePath) => await ImageDelete(deletedImagePath));
                    getdatalist(HomePageSectionId);
                    onClearButton();
                    dispatch({ type: 'ALERTING', message: updateNewsLetter.message })
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch(loaderActions.end());
                    dispatch({ type: 'ALERTING', message: updateNewsLetter.message })
                    return;
                }
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());
    }

    const columns = [
        {
            name: 'Sr. No.',
            sortable: true,
            float: "left",
            minWidth: "20px",
            maxWidth: "20px",
            selector: (data, index) => index + 1,
            omit: (HomePageSectionId === 16)
        },
        {
            name: 'Sequence Number',
            key: 'SeqNo',
            sortable: true,
            float: "left",
            selector: (data) => data?.SeqNo,
        },
        {
            name: 'State',
            key: 'StateName',
            sortable: true,
            float: "left",
            selector: (data) => data?.StateName,
        },
        {
            name: 'City',
            key: 'City',
            sortable: true,
            float: "left",
            selector: (data) => data?.City,
        },
        {
            name: 'Activity',
            key: 'ActivityName',
            sortable: true,
            float: "left",
            selector: (data) => data?.ActivityName,
            omit: (HomePageSectionId === 4 || HomePageSectionId === 19)
        },
        {
            name: 'Image File Name',
            sortable: true,
            float: "left",
            selector: (data) => data?.ImageName,
            omit: HomePageSectionId === 4
        },
        {
            name: 'Price Start from',
            key: 'PriceStartFrom',
            sortable: true,
            float: "left",
            selector: (data) => data?.PriceStartFrom,
            omit: (HomePageSectionId === 19 || HomePageSectionId === 16)
        },
        {
            name: 'Discount Up to',
            key: 'Discount',
            sortable: true,
            float: "left",
            selector: (data) => data?.Discount,
            omit: (HomePageSectionId === 19 || HomePageSectionId === 16)
        },
        {
            name: 'Edit',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'edit')} disabled={!useredit}
            ><i className="fa fa-edit eye-icon"></i></button>
        },
        {
            name: 'View',
            selector: data => <button type='button' className='border-0 p-0 bg-body set_disableclr' onClick={() => onEditorView(data, 'view')} ><i className="fa fa-eye" ></i></button>
        }
    ]

    const GetbyendpointList = (homePageSectionId, HolidaysId, ActivityMerchandisingId) => {
        let endpoint = '';
        switch (homePageSectionId) {
            case 4:
                endpoint = `/master/v1/getholidaybyid?holidayId=${HolidaysId}`;
                break;
            case 19:
                endpoint = `/master/v1/GetActivityMerchandisingById?activityMerchandisingId=${ActivityMerchandisingId}`;
                break;
            default:
                endpoint = '/master/v1/gettopindianmerchandisinglist';
                break;
        }
        return endpoint
    }

    const onEditorView = async (data, type) => {
        let res = {}
        if (type === 'view') {
            setSerachDisable(true)
        }
        setEditDisable(true)
        dispatch(loaderActions.start());
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            if (HomePageSectionId === 16) {
                res = { ...res, data, status: true }
            }
            else {
                res = await getAllData(GetbyendpointList(HomePageSectionId, data?.HolidaysId, data?.ActivityMerchandisingId))
            }
            setFormError({});
            if (res?.status) {
                const state = city?.filter((city) => city?.value === res?.data?.LocationId);
                setStateId(state?.[0]?.StateId)
                setFormValue(
                    {
                        HolidaysId: res?.data?.HolidaysId,
                        HomePageSectionId: HomePageSectionId,
                        LocationId: res?.data?.LocationId,
                        ImagePath: res?.data?.ImagePath,
                        ImageName: res?.data?.ImageName,
                        ImageFile: "",
                        SeqNo: res?.data?.SeqNo,
                        type: type,
                        GalleryId: res?.data?.GalleryId,
                        ActivityMerchandisingId: res?.data?.ActivityMerchandisingId,
                        //Top Indian
                        TopIndianMerchandisingId: res?.data?.TopIndianMerchandisingId,
                        ActivityId: res?.data?.ActivityId,
                        Descriptions: res?.data?.Descriptions,
                    }
                )
                getpriceanddiscount(res?.data?.LocationId)
            }
        } else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            dispatch(loaderActions.end());
        }
        dispatch(loaderActions.end());
    }

    const onClearButton = () => {
        setStateId(0);
        setPriceData({})
        setFormError({});
        setEditDisable(false);
        setSerachDisable(false)
        setFormValue(
            {
                HolidaysId: 0,
                HomePageSectionId: HomePageSectionId,
                LocationId: 0,
                ImagePath: "",
                ImageName: "",
                ImageFile: "",
                SeqNo: '',
                GalleryId: 0,
                ActivityMerchandisingId: 0,

                TopIndianMerchandisingId: 0,
                ActivityId: 0,
                Descriptions: ''
            }
        )
    }

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>{getTitleName(travelCategoryId)}</h3>
            </div>
            <div className="container-fluid form_border pb-5 pt-4 my-3">
                <div className='px-xl-5'>
                    <div className=" heading_color mb-3">
                        <h4>{name}</h4>
                    </div>

                    <form action=" " className=' mb-5' >
                        <div className='row'>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Country</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <div className="input-group">
                                            <Select
                                                id='FromCountryId'
                                                className="dropdown w-100 select_dropdown"
                                                options={countryCity?.countryData}
                                                value={countryCity?.countryData?.find((serachoption) => serachoption.value === 1) || null}
                                                isDisabled={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">State</label>
                                    </div>
                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <div className="input-group">
                                            <Select
                                                id='StateId'
                                                className="dropdown w-100 select_dropdown"
                                                options={countryCity?.stateData}
                                                value={countryCity?.stateData?.find((serachoption) => serachoption?.value === stateId) || null}
                                                onChange={(val) => handleDropDown("StateId", val)}
                                                isDisabled={formValue?.type === 'view' ? true : false}
                                            />
                                        </div>
                                        {formError?.stateId && <div className='text-danger text-start'>{formError?.stateId}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">City</label>
                                    </div>

                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <div className="input-group">
                                            <Select
                                                className="dropdown w-100 select_dropdown"
                                                id='LocationId'
                                                options={CityOptions}
                                                value={CityOptions?.find((option) => option.value === formValue?.LocationId) || null}
                                                onChange={(val) => handleDropDown('LocationId', val)}
                                                isDisabled={formValue?.type === 'view' ? true : false || stateId ? false : true}
                                            />
                                        </div>
                                        {formError.LocationId && <div className='text-danger text-start'>{formError.LocationId}</div>}
                                    </div>
                                </div>
                            </div>
                            {
                                HomePageSectionId === 16 &&
                                <div className='col-6'>
                                    <div className='row my-1'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="SelectActivity" className="col-form-label required">Select Activity</label>
                                        </div>

                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <div className="input-group">
                                                <Select
                                                    className="dropdown w-100 select_dropdown"
                                                    id='SelectActivity'
                                                    options={activityList}
                                                    value={activityList?.find((option) => option.value === formValue?.ActivityId) || null}
                                                    onChange={(val) => handleDropDown('ActivityId', val)}
                                                    isDisabled={formValue?.type === 'view' ? true : false}
                                                />
                                            </div>
                                            {formError.ActivityId && <div className='text-danger text-start'>{formError.ActivityId}</div>}
                                        </div>
                                    </div>
                                    {formValue?.ActivityId > 0 && <div className="text-center">
                                        <img loading='lazy' style={{ objectFit: 'fill', width: '100px', height: '100px' }} src={`${CommonFileURLWithFolder}${activityList?.find((el) => el.value === formValue?.ActivityId)?.imagePath}`} alt="" />
                                    </div>}
                                </div>
                            }
                            {
                                !(HomePageSectionId === 16) && <div className='col-6'>
                                    <div className='row my-1'>
                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="inputPassword6" className="col-form-label required">Images</label>
                                        </div>

                                        <div className=" col-lg-8 col-md-12 col-sm-12">
                                            <div className="input-group">
                                                {(HomePageSectionId === 19) ? <><input
                                                    type="file"
                                                    name='FromImageName'
                                                    id="FromImageName-id"
                                                    className="form-control btn_add"
                                                    accept=".png"
                                                    onChange={(e) => handleUploadImageLoad('FromImageName', e, name)}
                                                    disabled={formValue?.type === 'view' ? true : false}
                                                />
                                                    <label className="input-group-text" htmlFor="FromImageName-id">Browse</label>
                                                </>
                                                    :
                                                    <Select
                                                        className="dropdown w-100 select_dropdown"
                                                        id='imageSelect'
                                                        options={ImageList}
                                                        value={ImageList?.find((option) => option.value === formValue?.GalleryId) || null}
                                                        onChange={(val) => handleSelectImage(val)}
                                                        isDisabled={formValue?.type === 'view' ? true : false}
                                                    />
                                                }
                                            </div>
                                            {formValue?.ImageName && <div className=' text-start w-100 text-break'>{formValue?.ImageName}</div>}
                                            {formError?.ImageName && <div className='text-danger text-start'>{formError?.ImageName}</div>}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='col-6'>
                                <div className='row my-1'>
                                    <div className="col-lg-4 col-md-12 col-sm-12">
                                        <label htmlFor="inputPassword6" className="col-form-label required">Sequence Number</label>
                                    </div>

                                    <div className=" col-lg-8 col-md-12 col-sm-12">
                                        <div className="input-group">
                                            <input
                                                type="text" id="Sequence-Number"
                                                className="form-control btn_add"
                                                placeholder="Sequence Number"
                                                maxLength={4}
                                                name='SeqNo'
                                                onChange={(val) => handleChange('SeqNo', Number(onlyNumeric(val.target.value)) > 0 ? Number(onlyNumeric(val.target.value)) : "")}
                                                value={formValue?.SeqNo}
                                                disabled={formValue?.type === 'view' ? true : false}
                                            />
                                        </div>
                                        {formError?.SeqNo && <div className='text-danger text-start'>{formError?.SeqNo}</div>}
                                    </div>
                                </div>
                            </div>
                            {
                                (HomePageSectionId === 4) &&
                                <React.Fragment>
                                    <div className='col-6'>
                                        <div className='row my-1'>
                                            <div className="col-lg-4 col-md-12 col-sm-12">
                                                <label htmlFor="inputPassword6" className="col-form-label">Price start From</label>
                                            </div>

                                            <div className=" col-lg-8 col-md-12 col-sm-12">
                                                <div className="input-group">
                                                    <input
                                                        type="text" id="customer-name"
                                                        className="form-control btn_add"
                                                        placeholder="Price start From"
                                                        maxLength={150}
                                                        name='CustomerName'
                                                        defaultValue={pricedata?.PriceStartFrom}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='row my-1'>
                                            <div className="col-lg-4 col-md-12 col-sm-12">
                                                <label htmlFor="inputPassword6" className="col-form-label">Discount Up to</label>
                                            </div>

                                            <div className=" col-lg-8 col-md-12 col-sm-12">
                                                <div className="input-group">
                                                    <input
                                                        type="text" id="customer-name"
                                                        className="form-control btn_add"
                                                        placeholder="Discount Up to"
                                                        maxLength={150}
                                                        name='CustomerName'
                                                        defaultValue={pricedata?.Discount}
                                                        disabled
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            }
                        </div>
                    </form>
                    <CommonFilter
                        columns={columns}
                        filterList={filterData}
                        searchDisabled={serchdisable}
                        getdata={getdatalist}
                        setlistdata={setDataList}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={dataList}
                        PdfExport={false}
                        ExportToExcel={false}
                        disabled={false}
                    />

                    <div className="d-flex justify-content-center">
                        {
                            formValue?.type === 'edit'
                                ? (<button className="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={editDisable || !useredit}
                                >Update</button>
                                )
                                : (<button className="btn btn-primary mx-1" id="btnAdd" type='button'
                                    onClick={() => onSubmitData()}
                                    disabled={(formValue?.type === 'view' ? editDisable : false) || !useradd}
                                >Add</button>)
                        }

                        <button type="button" className="btn btn-primary mx-1" id="btnClear"
                            onClick={() => onClearButton({})}
                        >Clear</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Domestic